import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const NAVY = [11, 25, 44];      // #0B192C
const ORANGE = [232, 121, 26];  // #E8791A
const SLATE = [203, 213, 225];  // #CBD5E1

const HEADER_H = 46;
const MARGIN = 24;

function drawHeader(pdf, pageW, { title, subtitle }) {
  pdf.setFillColor(...NAVY);
  pdf.rect(0, 0, pageW, HEADER_H, "F");
  pdf.setFillColor(...ORANGE);
  pdf.rect(0, HEADER_H, pageW, 3, "F");

  pdf.setTextColor(255, 255, 255);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(14);
  pdf.text(title, MARGIN, 21);

  pdf.setTextColor(...ORANGE);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(9);
  pdf.text("CHARLES SERVICES", pageW - MARGIN, 18, { align: "right" });

  pdf.setTextColor(...SLATE);
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(8.5);
  pdf.text(subtitle, MARGIN, 34);
}

// Capture a DOM node and lay it into a branded landscape PDF, paginating when tall.
export async function exportDashboardPdf(node, meta = {}) {
  const canvas = await html2canvas(node, {
    scale: 2,
    backgroundColor: "#ffffff",
    useCORS: true,
    logging: false,
    windowWidth: node.scrollWidth,
  });

  const pdf = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();

  const imgW = pageW - MARGIN * 2;
  const scale = imgW / canvas.width;               // source px -> pt
  const contentTop = HEADER_H + 12;
  const contentH = pageH - contentTop - MARGIN;    // usable pt per page
  const sliceMaxPx = contentH / scale;             // source px per page

  const generated = new Date().toLocaleString();
  const title = `${meta.projectName || "Project"} — Dashboard`;
  const subtitle = `#${meta.projectNumber || "—"}   |   Reporting date: ${meta.reportingDate || "—"}   |   Generated ${generated}`;

  let renderedPx = 0;
  let page = 0;
  while (renderedPx < canvas.height) {
    const sliceH = Math.min(sliceMaxPx, canvas.height - renderedPx);
    const tmp = document.createElement("canvas");
    tmp.width = canvas.width;
    tmp.height = sliceH;
    const ctx = tmp.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, tmp.width, tmp.height);
    ctx.drawImage(canvas, 0, renderedPx, canvas.width, sliceH, 0, 0, canvas.width, sliceH);

    if (page > 0) pdf.addPage();
    drawHeader(pdf, pageW, { title, subtitle });
    pdf.addImage(tmp.toDataURL("image/jpeg", 0.92), "JPEG", MARGIN, contentTop, imgW, sliceH * scale);

    renderedPx += sliceH;
    page += 1;
  }

  const safe = String(meta.projectNumber || "project").replace(/[^\w.-]+/g, "_");
  pdf.save(`dashboard_${safe}.pdf`);
}
